import LinkIcon from "@mui/icons-material/Link";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import { Box, Button } from "@mui/material";
import { AiAssistedSparklesIcon } from "../AiAssistedSparklesIcon";
import {
  getRecipeAssistedMethodButtonConfigs,
  type RecipeAssistedEntryActions,
  type RecipeAssistedMethodKey,
} from "./recipeAssistedEntry";

export type RecipeAssistedMethodButtonsProps = RecipeAssistedEntryActions;

const compactButtonSx = {
  minWidth: 32,
  minHeight: 32,
  height: 32,
  px: 1.5,
  py: 0.75,
  gap: 0.75,
  fontSize: 13,
  fontWeight: 600,
  lineHeight: "20px",
  borderColor: "greyscale.300",
  color: "text.primary",
  "& .MuiButton-startIcon": {
    marginRight: 0.5,
    marginLeft: 0,
  },
  "&:focus-visible": {
    outline: "2px solid",
    outlineColor: "info.main",
    outlineOffset: 2,
  },
};

const methodIcon = (key: RecipeAssistedMethodKey) => {
  switch (key) {
    case "link":
      return <LinkIcon sx={{ fontSize: 18 }} />;
    case "photo":
      return <PhotoCameraOutlinedIcon sx={{ fontSize: 18 }} />;
    case "ai":
      return <AiAssistedSparklesIcon sx={{ fontSize: 18 }} />;
  }
};

export const RecipeAssistedMethodButtons = (props: RecipeAssistedMethodButtonsProps) => {
  const buttons = getRecipeAssistedMethodButtonConfigs(props);
  if (buttons.length === 0) {
    return null;
  }

  return (
    <Box role="group" aria-label="Assisted recipe methods" sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
      {buttons.map(button => (
        <Button
          key={button.key}
          variant="outlined"
          size="small"
          onClick={button.onClick}
          startIcon={methodIcon(button.key)}
          aria-label={button.ariaLabel}
          sx={compactButtonSx}
        >
          {button.label}
        </Button>
      ))}
    </Box>
  );
};
